import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { TabId } from '../../types';
import TabPanel from '../BuildPreviewTabs/TabPanel';
import { GraphEditor } from '../GraphEditor';
import Toolbars from '../GraphEditorToolbars';
import PreviewPanel from '../PreviewPanel';
import { ConnectedPropertiesSidebar } from '../PropertiesSidebar';

type MainPanelProps = {
  hideDescriptionPanel: () => void;
  isDescriptionPanelExpanded: boolean;
  workflowId: string | undefined;
  activeTabId: TabId;
  onClickReturnToWorkflow: () => void;
};

export const MainPanel = ({
  hideDescriptionPanel,
  isDescriptionPanelExpanded,
  workflowId,
  activeTabId,
  onClickReturnToWorkflow,
}: MainPanelProps): JSX.Element => {
  return (
    <Box position="relative" height="100%">
      {/* NOTE(IL, 2024-03-12): relative+absolute trick is to allow GraphEditor to be
    100% of remaining height accounting for position:fixed navbar, while also allowing
    PropertiesSidebar etc to independently scroll in Y if it overflows. */}

      <Stack position="relative" height="100%" flex="2">
        <TabPanel
          id="build"
          containerProps={{ height: '100%' }}
          activeTabId={activeTabId}
        >
          <Stack flexDirection="row" height="100%">
            <Box
              height="100%"
              flex={1}
              bgcolor="grey.100"
              borderRight="1px solid"
              borderColor="grey.400"
            >
              <GraphEditor />
            </Box>
            <Toolbars
              isDescriptionPanelExpanded={isDescriptionPanelExpanded}
              hideDescriptionPanel={hideDescriptionPanel}
            />
            <ConnectedPropertiesSidebar />
          </Stack>
        </TabPanel>
        <TabPanel
          id="preview"
          containerProps={{ height: '100%' }}
          activeTabId={activeTabId}
        >
          <PreviewPanel
            workflowId={workflowId}
            onClickReturnToWorkflow={onClickReturnToWorkflow}
            isDescriptionPanelExpanded={isDescriptionPanelExpanded}
          />
        </TabPanel>
      </Stack>
    </Box>
  );
};
